// Preload critical images during splash screen
export const preloadImages = (imageUrls) => {
  return Promise.all(
    imageUrls.map((url) => {
      return new Promise((resolve, reject) => {
        const img = new Image();
        img.onload = () => resolve(url);
        img.onerror = () => {
          console.warn(`Failed to preload image: ${url}`);
          resolve(url); // Resolve anyway to not block
        };
        img.src = url;
      });
    })
  );
};

// Every image asset shipped under public/ (used to gate the splash screen)
export const ALL_PUBLIC_IMAGES = [
  '/atlas/hero-2.png',
  '/atlas/hero-3.png',
  '/atlas/cat1.png',
  '/product/metal-2.png',
  '/product/plastic-2.png',
  '/sponsors/alva.png',
  '/sponsors/aws.png',
  '/sponsors/coryfire.png',
  '/sponsors/hkdc.png',
  '/sponsors/hkstp.png',
  '/sponsors/hky.png',
  '/sponsors/ip.png',
  '/sponsors/mplus.png',
  '/sponsors/oneDegree.png',
  '/sponsors/pbc.png',
  '/sponsors/pf.png',
  '/sponsors/poly.png',
  '/sponsors/sponsor5.png',
  '/sponsors/sponsor6.png', 
  '/sponsors/sponsor7.png',
  '/icons/ptagair-2.png',
  "/icons/ptag-2.png",
  "/icons/head-manage.png",
  "/icons/head-finder.png",
  "/icons/head-shop.png",
  "/icons/head-lost.png",
  "/icons/head-adopt.png",
  "/icons/head-admin.png"
];
